import React, { useEffect, useMemo } from 'react'
import PropTypes from 'prop-types'
import { connect, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { employerEmployersList } from 'features/employer/store'
import { NoDataTextMessage, OverlayDataShower, Pagination } from 'components/Elements'
import { Grid } from './Grid'

const GeneralEmployersContainerComponent = ({ ...props }) => {
  const { t } = useTranslation()

  const dispatch = useDispatch()

  useEffect(() => {
    return () => {
      dispatch(employerEmployersList.cleanState({}))
    }
  }, [])

  useEffect(() => {
    fetchList()
  }, [props.page])

  const fetchList = () => {
    let params = {
      page: props.page,
      sort: [
        { id: 'premium_company', desc: true },
        { id: 'company_name', desc: false },
      ],
    }

    dispatch(employerEmployersList.getList({ params }))
  }

  const onPageChange = item => {
    dispatch(employerEmployersList.setPage(item.selected + 1))
  }

  const isLoading = useMemo(() => {
    return props.loading
  }, [props.loading])

  return (
    <>
      <h4 className="font-size-18">{t('employers')}</h4>

      <OverlayDataShower isLoading={isLoading} isFailed={!!props.error} error={props.error}>
        <Grid items={props.list} />

        <Pagination data={props.meta} onPageChange={onPageChange} className={'mt-2'} />
      </OverlayDataShower>

      {!props.list.length && !props.loading && !props.error && (
        <NoDataTextMessage>{t('no_employers')}</NoDataTextMessage>
      )}
    </>
  )
}

GeneralEmployersContainerComponent.propTypes = {}

const mapStateToProps = state => {
  const { list, loading, error, meta, page } = state.employer.employers.list
  return {
    list,
    loading,
    error,
    meta,
    page,
  }
}

export const GeneralEmployersContainer = connect(mapStateToProps)(
  GeneralEmployersContainerComponent
)
